export default "__VITE_ASSET__BmNRUIga__"